import { create } from 'zustand';

export const usePagesStore = create((set) => ({
  selectedPageId: null,
  setSelectedPageId: (selectedPageId) => set({ selectedPageId }),
}));
